/**
 * Parse a server timestamp into a Date, correctly interpreting naive
 * (timezone-less) ISO strings as UTC so they render in the user's local
 * browser timezone. Backend stores many timestamps via
 * datetime.utcnow().isoformat() which omits the trailing "Z".
 */
export const parseServerDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
  let s = String(value);
  const hasTz = /[zZ]$|[+-]\d{2}:?\d{2}$/.test(s);
  if (s.includes('T') && !hasTz) s += 'Z';
  const d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
};

/**
 * Format date to: DD MON YYYY (e.g., 19 Oct 2025)
 */
export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return 'Invalid Date';
  
  const day = date.getDate().toString().padStart(2, '0');
  const month = date.toLocaleString('en-US', { month: 'short' });
  const year = date.getFullYear();
  
  return `${day} ${month} ${year}`;
};

/**
 * Format time to: HH:MM:SS in 24-hour format (e.g., 19:59:15)
 */
export const formatTime = (dateString) => {
  if (!dateString) return 'N/A';
  
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return 'Invalid Time';
  
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');
  
  return `${hours}:${minutes}:${seconds}`;
};

/**
 * Format date and time together: DD MON YYYY HH:MM:SS
 */
export const formatDateTime = (dateString) => {
  if (!dateString) return 'N/A';
  
  return `${formatDate(dateString)} ${formatTime(dateString)}`;
};
